// Extrai a mensagem de erro de uma resposta do backend.
// Erros de negócio vêm em data.message; erros de validação (Bean Validation) vêm em data.parameterViolations,
// sem message, e por isso as telas mostravam só o texto genérico.
export function mensagemErroApi(err, padrao = 'Erro ao processar a requisição.') {
	const data = err && err.response ? err.response.data : null
	if (!data) return padrao
	if (typeof data === 'string') return data
	if (data.mensagem) return data.mensagem
	if (data.message) return data.message
	if (data.motivoSefaz) return `SEFAZ: ${data.motivoSefaz}`
	const violacoes = [...(data.parameterViolations || []), ...(data.propertyViolations || [])]
	if (violacoes.length) {
		return violacoes.map(v => `${String(v.path || '').split('.').pop()}: ${v.message}`).join('; ')
	}
	return padrao
}
